import { render, staticRenderFns } from "./TechPreview.vue?vue&type=template&id=227a891e&scoped=true&"
var script = {}
import style0 from "./TechPreview.vue?vue&type=style&index=0&id=227a891e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227a891e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('227a891e')) {
      api.createRecord('227a891e', component.options)
    } else {
      api.reload('227a891e', component.options)
    }
    module.hot.accept("./TechPreview.vue?vue&type=template&id=227a891e&scoped=true&", function () {
      api.rerender('227a891e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TechPreview.vue"
export default component.exports